<div
    *ngIf="_field && series"
    class="agpr-seriesPickerItem"
    [class.agpr-seriesPickerItem--hasFilters]="hasActiveFilters"
    role="group"
    [attr.aria-labelledby]="ariaLabelledBy"
>
    <div
        class="agpr-seriesPickerItem-source"
    >
        <div
            class="agpr-seriesPickerItem-inputGroup"
        >
            <agpr-dropdown
                [id]="id + '-seriesPickerItemDropdown'"
                [options]="typeOptions"
                ariaLabel="Source.type"
                [(ngModel)]="selectedType"
                (ngModelChange)="selectType($event.value)"
            ></agpr-dropdown>
            <div class="agpr-seriesPickerItem-autocompleteWrapper">
                <agpr-autocomplete
                    class="agpr-seriesPickerItem-autocomplete"
                    [id]="id + '.autocomplete'"
                    [suggestions]="getSuggestions$()"
                    labelField="label"
                    [placeholder]="'Reports.series.type.' + series.type + '.placeholder'"
                    [dropdown]="true"
                    [clearOnBlur]="false"
                    [(ngModel)]="selectedOption"
                    (itemSelected)="selectItem($event)"
                    (clear)="selectItem(null)"
                    (focus)="onInputFocus()"
                    (blur)="onInputBlur()"
                    [ariaLabel]="'Reports.series.type.' + series.type + '.placeholder'"
                    [required]="_field.required"
                    [ariaInvalid]="ariaInvalid ? ariaInvalid : showError"
                    [ariaDescribedBy]="ariaDescribedBy ? ariaDescribedBy : id + '_invalidSourceError'"
                    [showHiddenOption]="showHiddenOption"
                ></agpr-autocomplete>
            </div>
            <div class="agpr-seriesPickerItem-filterButton">
                <agpr-filter-dropdown
                    [id]="id"
                ></agpr-filter-dropdown>
            </div>
        </div>
        <div
            *ngIf="hasActiveFilters"
            class="agpr-seriesPickerItem-filterChips"
        >
            <agpr-filter-chips
                [id]="id">
            </agpr-filter-chips>
        </div>
    </div>
    <div class="agpr-seriesPickerItem-inputGroup">
        <agpr-text-input
            [maxlength]="64"
            placeholder="Reports.series.label.placeholder"
            ariaLabel="Reports.series.label.ariaLabel"
            [id]="id + '.seriesLabelTextInput'"
            [(ngModel)]="series.label"
            (change)="labelChanged($event.target.value)"
            [bottomMargin]="false"
            (focus)="onInputFocus()"
            (blur)="onInputBlur()"
        ></agpr-text-input>

        <agpr-color-picker-field
            *ngIf="showColorSwatch"
            class="agpr-seriesPickerItem-colorSwatch"
            [id]="id + '.colorSwatch'"
            [config]="{
                initialValue: series?.color || defaultColors[index],
                showRecentColors: true
            }"
            [value]="series?.color || defaultColors[index]"
            (changes)="handleColorChange($event)"
        ></agpr-color-picker-field>

    </div>
</div>
<agpr-form-message
    *ngIf="showError"
    [id]="id + '_invalidSourceError'"
>
    {{ (!selectedOption ? 'Reports.series.dataSourceRequired' : 'Reports.series.invalidSource') | localize }}
</agpr-form-message>
